import styles from 'modules/User/Security/Security.module.scss'
import Enable2FA from 'modules/Forms/2FA/Enable'
import Disable2FA from 'modules/Forms/2FA/Disable'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_2FA } from './types'
import GridSpinner from 'components/UI/GridSpinner'

const Setup = () => {
  const dispatch = useDispatch()
  const { enabled, initialized } = useSelector((state) => state['user/2fa'])
  useEffect(() => dispatch({ type: GET_2FA }), [])

  return (
    <div>
      <div className={styles['security']}>
        <div className={styles['security__inner']}>
          {!initialized ? <GridSpinner /> : enabled ? <Disable2FA /> : <Enable2FA />}
        </div>
      </div>
    </div>
  )
}
export default Setup
